import { shareEntityButtonStyles } from "@waytek/Overrides/Components/ShareEntityButton";

shareEntityButtonStyles.container = {
    ...shareEntityButtonStyles.container,

    gap: 10,
};
